import { accountActions } from 'core/Account';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    ErrorMessage,
    LoginLayout
} from 'views/components';
import {
    ExpandButton,
    FormGroup,
    Input,
    LinkLabel
} from 'mol-ui';
import {
    FooterContainer,
    TextLine
} from './styled';
import React, { useState } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const ResetPassword = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { error } = useSelector('account');
    const { push } = useHistory();

    const [email, setEmail] = useState('');

    const handleChange = value => {
        setEmail(value);
        if (error) {
            dispatch(accountActions.setAccountError(''));
        }
    };

    const handleSubmit = () => {
        if (!!email) {
            dispatch(accountActions.resetPassword(email));
        }
    };

    return (
        <LoginLayout title={ t('Reinicio de contraseña') }>
            <TextLine>
                { t('Enviaremos un email a la casilla registrada con su nueva contraseña') }.
            </TextLine>
            <TextLine>
                { t('Recuerde que puede reiniciar su contraseña desde su perfil') }.
            </TextLine>
            <FormGroup label={ t('Email') } marginTop="30px">
                <Input
                    error={ !!error }
                    height="50px"
                    type="email"
                    value={ email }
                    onChange={ handleChange }
                    onEnterPress={ handleSubmit }
                />
            </FormGroup>
            <ErrorMessage relative error={ error } />
            <FooterContainer>
                <ExpandButton
                    caption={ t('Confirmar') }
                    disabled={ !email }
                    margin="0px 0px 20px 0px"
                    size={ 100 }
                    onClick={ handleSubmit }
                />
                <LinkLabel onClick={ () => push(t('/login')) }>
                    { t('Volver al inicio de sesión') }
                </LinkLabel>
            </FooterContainer>
        </LoginLayout>
    );
};

ResetPassword.propTypes = {

};

export default ResetPassword;
